import { Flex } from "@chakra-ui/react";
import { useRecoilValue } from "recoil";

import { Overlay } from "components/Overlay";
import { OFButton } from "design_system/components/OFButton";
import { CURRENT_COUNTRY } from "src/constants/Countries";
import {
  areDisabledCheckoutButtonsState,
  isCartUpdatingState,
  isCheckoutButtonLoadingState
} from "src/states";
import getNameProp from "src/utils/getNameProp";

interface Props {
  t: (key: string, values?: any) => string;
  onCheckoutClick: () => void;
  handleSubmit: (values: any) => any;
  onSubmit: (values: any, isUsingWallet: boolean, paymentId: string) => void;
  walletRef: React.RefObject<any>;
  items: any[];
  setValue: (name: string, value: unknown, config?: any) => void;
  trigger: (values?: any) => void;
  errors: any;
}

export const CheckoutButtons = ({ t, onCheckoutClick, items }: Props) => {
  const isCheckoutButtonLoading = useRecoilValue(isCheckoutButtonLoadingState);
  const areDisabled = useRecoilValue(areDisabledCheckoutButtonsState);
  const isCartUpdating = useRecoilValue(isCartUpdatingState);

  return (
    <Overlay isLoading={isCartUpdating} h="max-content" display="flex" justifyContent="center">
      <Flex gap="24px" flexDirection="column" alignItems="center" w="max-content">
        <OFButton
          onClick={onCheckoutClick}
          isLoading={isCheckoutButtonLoading}
          isDisabled={items?.length === 0 || areDisabled}
          {...getNameProp("checkout-button")}
        >
          {t(`checkout:${CURRENT_COUNTRY}_checkout_button_text`)}
        </OFButton>
      </Flex>
    </Overlay>
  );
};

export default CheckoutButtons;
